module.exports = __webpack_public_path__ + "static/img/process-22.d1ce418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/process-22.png
// module id = JyDb
// module chunks = 0